import { combineReducers } from 'redux';

import {
  initScenesRequest,
  initScenesSuccess,
  initScenesFail,
} from '../actions';
import { ScenesAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { Scenes } from '../../../../types/items';

type State = Loadable<Scenes>;
type ReducerOf<T extends keyof State> = Reducer<State, ScenesAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case initScenesRequest.type:
      return null;

    case initScenesSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case initScenesRequest.type:
      return true;

    case initScenesSuccess.type:
    case initScenesFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
});
